// Shared markup for the React page and the statically delivered KI page.
function renderAiThreeSteps() {
    return `<section class="topic-ai-steps" aria-labelledby="topic-ai-steps-title">
  <div class="topic-v2-container">
    <div class="topic-ai-steps-heading">
      <p class="topic-v2-eyebrow">COMMETRIQ KI-ANALYST</p>
      <h2 id="topic-ai-steps-title">In 3 Schritten zu datenbasierten Antworten</h2>
      <p>Verbinde deine JTL-Wawi-Daten, stelle eine Frage in deinen Worten und prüfe die Antwort anhand der zugrunde liegenden Kennzahlen.</p>
    </div>
    <div class="topic-ai-steps-grid">
      <article class="topic-ai-step-card topic-ai-step-connect">
        <span class="topic-ai-step-number">01</span>
        <h3>Daten verbinden</h3>
        <p>JTL-Wawi mit Commetriq verknüpfen. Du wählst aus, welche Datenbereiche für die Analyse genutzt werden dürfen.</p>
        <div class="topic-ai-connect-visual">
          <div class="topic-ai-connection" aria-label="JTL-Wawi-Daten über eine Datenverbindung mit Commetriq verknüpfen">
            <div class="topic-ai-brand topic-ai-brand-jtl"><img src="/integration-logos/jtl-wawi.png" alt="JTL-Wawi" loading="lazy" /></div>
            <span class="topic-ai-flow-line" aria-hidden="true"></span>
            <div class="topic-ai-brand topic-ai-brand-data" aria-label="Datenverbindung"><svg viewBox="0 0 48 48" fill="none" aria-hidden="true"><ellipse cx="24" cy="11" rx="15" ry="6"/><path d="M9 11v25c0 3.3 6.7 6 15 6s15-2.7 15-6V11M9 23c0 3.3 6.7 6 15 6s15-2.7 15-6M9 35c0 3.3 6.7 6 15 6s15-2.7 15-6"/></svg></div>
            <span class="topic-ai-flow-line" aria-hidden="true"></span>
            <div class="topic-ai-brand topic-ai-brand-cmq"><img src="/commetriq-mark.webp" alt="Commetriq-Signet" loading="lazy" /></div>
          </div>
          <fieldset class="topic-ai-permissions">
            <legend><span>Daten für Analysen</span><small>Beispielauswahl</small></legend>
            <div class="topic-ai-permission-options">
              <label><input type="checkbox" checked="checked" /><span>Bestellungen</span></label>
              <label><input type="checkbox" checked="checked" /><span>Artikel</span></label>
              <label><input type="checkbox" checked="checked" /><span>Lagerbestand</span></label>
              <label><input type="checkbox" /><span>Retouren</span></label>
            </div>
            <p>Nur ausgewählte Datenbereiche berücksichtigen</p>
          </fieldset>
        </div>
      </article>
      <article class="topic-ai-step-card topic-ai-step-question">
        <span class="topic-ai-step-number">02</span>
        <h3>Frage stellen</h3>
        <p>Stell deine Frage in deinen Worten. Der Analyst hilft, die passende Auswertung einzugrenzen.</p>
        <div class="topic-ai-question-visual">
          <img src="/ki-analyst-robot.png" alt="Commetriq-Roboter als Begleiter für die Frage" width="1220" height="1220" loading="lazy" decoding="async" />
          <div class="topic-ai-question-list" aria-label="Beispielfragen">
            <div>Warum sinkt meine Marge?</div>
            <div>Welche Artikel werden knapp?</div>
            <div>Woher kommen die Retouren?</div>
          </div>
        </div>
      </article>
      <article class="topic-ai-step-card topic-ai-step-answer">
        <span class="topic-ai-step-number">03</span>
        <h3>Antwort prüfen</h3>
        <p>Die Antwort trennt Beobachtung, mögliche Ursache und nächsten Prüfschritt.</p>
        <div class="topic-ai-answer-preview" aria-label="Beispielantwort zur Marge">
          <div class="topic-ai-answer-top"><span class="topic-ai-answer-kicker">Antwort auf die Margenfrage</span><span class="topic-ai-answer-status">Prüfung offen</span></div>
          <strong>Die Marge ist gesunken.</strong>
          <div class="topic-ai-answer-row"><b>Beobachtung</b><span>Rückgang gegenüber dem Vormonat</span></div>
          <div class="topic-ai-answer-row"><b>Mögliche Spur</b><span>Gebühren oder veränderter Artikelmix</span></div>
          <div class="topic-ai-answer-next"><span aria-hidden="true">↗</span><span>Als Nächstes: Kanäle und betroffene Artikel vergleichen</span></div>
        </div>
      </article>
    </div>
  </div>
</section>`;
}

module.exports = { renderAiThreeSteps };
